import Vue from 'vue'
import PortalVue from '@linusborg/vue-simple-portal' // Добавили @linusborg/

Vue.use(PortalVue)